module.exports = __webpack_public_path__ + "static/media/sketch.40844024.png";